import { render, staticRenderFns } from "./ValidationStatus.vue?vue&type=template&id=83c4f546&scoped=true"
import script from "./ValidationStatus.vue?vue&type=script&lang=js"
export * from "./ValidationStatus.vue?vue&type=script&lang=js"
import style0 from "./ValidationStatus.vue?vue&type=style&index=0&id=83c4f546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c4f546",
  null
  
)

export default component.exports